import React from "react";
import { useNavigate } from "react-router-dom";

const Nosotros = ({ onClick }) => {
  const navigate = useNavigate();

  return (
    <button
      className="btn-link"
      onClick={() => {
        navigate("/profesionales");
        if (onClick) onClick();
      }}
    >
      NOSOTROS
    </button>
  );
};

export default Nosotros;
